const VIEWER_VERSION_NOTIFICATION_MESSAGES = {
  SAVE_SUCCESS: {
    title: 'Versión del visor guardada',
    message: 'La versión del visor de la organización se actualizó correctamente.',
  },
  SAVE_ERROR: {
    title: 'Ocurrió un error',
    message: 'No se pudo actualizar la versión del visor. Inténtalo de nuevo.',
  },
};

export default VIEWER_VERSION_NOTIFICATION_MESSAGES;
